import { forwardRef, type ComponentRef } from "react";

import { Button } from "../../atoms";
import { markPendingAware } from "../../lib/pending";
import type { WhatsAppButtonProps } from "./types";

/**
 * WhatsApp call-to-action using system success colors, WhatsappLogo icon,
 * and shared Button + Typography styles.
 *
 * Interaction states (idle, hover, pressed, loading, disabled) follow the underlying `Button`.
 */
export const WhatsAppButton = forwardRef<ComponentRef<typeof Button>, WhatsAppButtonProps>(
  ({ label, ...buttonProps }, ref) => {
    return (
      <Button
        ref={ref}
        variant="success"
        leadingIcon="WhatsappLogo"
        label={label}
        {...buttonProps}
        leadingIconWeight="fill"
      />
    );
  },
);

WhatsAppButton.displayName = "WhatsAppButton";
// Takes a parent Pressable's `disabled` and `pending` as Button does, so it
// looks disabled or busy under one (asChild)
markPendingAware(WhatsAppButton);
